import React from 'react';
import entities from 'entities';
import PropTypes from 'prop-types';
import {
  CompetitionWrapper, CompetitionRound,
  CompetitionName, CompetitionAllMatch, TwoPoints,
} from './styles';
import LabelLink from '../shared/LabelLink';
import { prettyCalendarTennisUrl, prettyCalendarUrl } from '../../common/rcs_gaz_mc_core_FE';
import * as types from '../../constants';

const CompetitionRow = ({
  name, round, isMobile, competitionId, isHighlight, phase, competitionLink, calendarLink, isRace,
  isTennis, competitionName, tournamentType, tournamentName, competitionSex, disableLink, isBasket,
}) => {
  const corriereLink = () => {
    let returnedLink = '';
    if (process.env.REACT_APP_SITE === 'corriere') {
      returnedLink = '/sport';
    }
    return returnedLink;
  };

  const tennisCleanTournament = (type) => {
    let label;
    if (type && type.indexOf('/') !== -1) {
      const typesArray = type.split(' / ');
      const [first, second] = typesArray;
      if (competitionSex === types.COMPETITION_TYPE_MAN) {
        label = first;
      } else {
        label = second;
      }
    } else {
      label = type;
    }
    return label;
  };

  return (
    <CompetitionWrapper classNameCustom="competitionWrap">
      <CompetitionName>
        {entities.decodeHTML(name)}
        <TwoPoints competitionId={competitionId} isBasket={isBasket}>:</TwoPoints>
      </CompetitionName>
      <CompetitionRound competitionId={competitionId} isBasket={isBasket}>
        {process.env.REACT_APP_SITE === 'gazzetta' || process.env.REACT_APP_SITE === 'corriere' ?
          <LabelLink
            disableLink={disableLink}
            classNameCustom="competition-title-top-left"
            color="linkColor"
            label={round}
            size={isMobile ? 0.8 : 1}
            path={isTennis ? `${prettyCalendarTennisUrl(
                  '8', competitionId, competitionName,
                tennisCleanTournament(tournamentType), tournamentName, false, process.env.REACT_APP_SITE,
                  )}` :
                isBasket ? `${prettyCalendarUrl('3', competitionId, process.env.REACT_APP_SITE)}` :
                  `${corriereLink()}${calendarLink}${competitionLink}/calendario-risultati/`}
          />
            :
                  <LabelLink
                    disableLink={disableLink}
                    classNameCustom="competition-title-top-left"
                    color="linkColor"
                    label={round}
                    size={isMobile ? 0.8 : 1}
                    path={isTennis ? `${prettyCalendarTennisUrl(
                        '8', competitionId, competitionName,
                tennisCleanTournament(tournamentType), tournamentName, false, process.env.REACT_APP_SITE,
                )}` :
                `${calendarLink}${competitionLink}/calendario-risultati/`}
                  />
          }
      </CompetitionRound>
      {isTennis && phase &&
             <LabelLink
               classNameCustom="competition-title-top-left"
               color="liveColor"
               label={phase}
               size={isMobile ? 0.8 : 1}
               path={isTennis ? `${prettyCalendarTennisUrl(
                '8', competitionId, competitionName,
        tennisCleanTournament(tournamentType), tournamentName, false, process.env.REACT_APP_SITE,
        )}` :
        `${calendarLink}${competitionLink}/calendario-risultati/`}
            />
      }
      {!isMobile && !isHighlight && !isRace && !isTennis &&
      <CompetitionAllMatch competitionId={competitionId}>
        {process.env.REACT_APP_SITE === 'gazzetta' || process.env.REACT_APP_SITE === 'corriere' ?
          <LabelLink
            classNameCustom="competition-title-top-right"
            color="linkColor"
            label={`Vedi tutta la ${!isRace ? 'giornata' : 'gara'}`}
            size={0.73}
            path={`${corriereLink()}${calendarLink}${competitionLink}/calendario-risultati/`}
            disableLink={disableLink}
          />
          :
          <LabelLink
            classNameCustom="competition-title-top-right"
            color="linkColor"
            label={`Vedi tutta la ${!isRace ? 'giornata' : 'gara'}`}
            size={0.73}
            path={`${calendarLink}${competitionLink}/calendario-risultati/`}
            disableLink={disableLink}
          />
        }
      </CompetitionAllMatch>
      }
    </CompetitionWrapper>
  );
};


CompetitionRow.propTypes = {
  name: PropTypes.any,
  round: PropTypes.any,
  isMobile: PropTypes.bool,
  competitionId: PropTypes.any,
  isHighlight: PropTypes.bool,
  competitionLink: PropTypes.any,
  calendarLink: PropTypes.any,
  isRace: PropTypes.bool,
  isTennis: PropTypes.bool,
  isBasket: PropTypes.bool,
  competitionName: PropTypes.any,
  tournamentType: PropTypes.any,
  tournamentName: PropTypes.any,
  competitionSex: PropTypes.any,
  disableLink: PropTypes.bool,
};

export default CompetitionRow;
